export const VehicleApiEndpoints = {
  MEDIA: '/media',
  CAP_MAKE: '/cap/make',
  VALIDATE_BASIC_CAR_DATA: '/auction/validate-car-basic-data',
  VEHICLE_MAKES: '/vehicle-make',
  VEHICLE_MODELS: '/vehicle-make',
  AUCTION_DRAFT: 'auction/draft',
  VEHICLE_FEATURES: '/vehicle-specification',
  VALIDATE_VEHICLE_MEDIA: '/auction/validate-vehicle-media',
  VEHICLE_DESCRIPTION_TEMPLATE: '/vehicle-description-template',
  VALIDATE_DESCRIPTION_AND_SETTINGS: '/auction/validate-description-and-settings',
  ORGANIZATION_MEMBER_DEFAULT_DESCRIPTION: '/organization-member/default-description',
  ORGANIZATION_LOCATIONS: '/account/organization-locations',
  ALL_VEHICLE_FEATURES: '/vehicle-specification',
  ORGANIZATION_GROUP: '/account/organization-group',
  VALIDATE_TYRE_TREAD_DEPTHS: '/auction/validate-tyre-tread-depths',
  VALIDATE_SERVICE_HISTORY: '/auction/validate-service-history',
  AUCTION: '/auction',
};
